
export const preferredLocale = {

    methods: {
        findPreferredLocale(subPanel) {
            const preferredLocale = localStorage.getItem('previewDefaultLocale');

            if (preferredLocale !== null) {
                const found = subPanel.locales.find(locale => locale.code === JSON.parse(preferredLocale));

                if (found) {
                    return found;
                }
            }
            return subPanel.locales[0];
        },

        setPreferredLocale(localeCode) {

            if (typeof localeCode === "string") {
                localStorage.setItem('previewDefaultLocale', JSON.stringify(localeCode));
                Bus.$emit('flash-message', {message: 'Ok. We will remember your preview locale for now on!'});
            }
        },
    },
};

